import { Container } from "../../components";
import React from "react";
import OverviewSection from "./OverviewSection";

export default function Banner() {
  return (
    <section className="relative flex">
      <Container className="h-full">
        <h1 className="text-center heading capitalize -tracking-[1.2px] md:-tracking-[2.24px] font-semibold text-textcolor mb-12">
          Delegate to validators and earn rewards!
        </h1>
        <div className="relative h-full border-[1.5px] border-white/[0.06] rounded-[20px] bg-heroBanner bg-cover bg-no-repeat bg-center">
          {/* <img
            className="object-cover w-full h-full rounded-[40px]"
            src={`${process.env.REACT_APP_S3_ASSETS_URL}gradientHeroBanner-bg.png`}
            alt="bg"
          /> */}
          <div className="p-4 lg:py-[43px] lg:px-[50px] w-full">
            <OverviewSection />
            {/* <p className="text-sm/6 md:text-lg -tracking-1 font-normal text-dim/70">
              Start securing the Vanar chain by delegating your tokens to
              trusted validators. By doing so, you help maintain the network's
              security and decentralization while earning rewards. Validators
              are responsible for producing blocks and validating transactions,
              and your delegation supports them in these tasks. Keep full
              ownership of your tokens while contributing to the network’s
              health and earning a share of rewards.{" "}
            </p> */}
          </div>
        </div>
      </Container>
    </section>
  );
}
